"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var myRegexp = /<iframe.*?src="(.*?)".*?<\/iframe>/;

var _default = function _default(embedCode) {
  var match = myRegexp.exec(embedCode);

  if (!match || !match[1]) {
    return null;
  }

  return match[1];
};

exports.default = _default;